import { isIndividual } from '@rma/generic/domain/helpers';
import { ProfileType } from '@rma/generic/domain/types';
import { ThemeParams } from './theme-params';

export type ProfileThemeImageType = 'bannerImage' | 'coverImage' | 'avatarImage';

export interface ThemeParamsCollection extends Record<ProfileThemeImageType, ThemeParams> {
  bannerImage: ThemeParams;
  coverImage: ThemeParams;
  avatarImage: ThemeParams;
}

const AGENT_IMAGE_CONFIGS: ThemeParamsCollection = {
  bannerImage: {
    imageType: 'ProfileBanner',
    width: 754,
    height: 140,
    resizeOption: 'FitToHeight',
    horizontalAlign: 'Left',
    verticalAlign: undefined,
  },
  coverImage: {
    imageType: 'ProfileCover',
    width: 955,
    height: 200,
    resizeOption: 'FitToWidth',
    verticalAlign: 'Center',
    horizontalAlign: undefined,
  },
  avatarImage: {
    imageType: 'Avatar',
    width: 400,
    height: 400,
    maxSize: 30,
    resizeOption: undefined,
    verticalAlign: 'Top',
    horizontalAlign: undefined,
  },
};

const AGENCY_IMAGE_CONFIGS: ThemeParamsCollection = {
  ...AGENT_IMAGE_CONFIGS,
  avatarImage: {
    imageType: 'Logo',
    width: 400,
    height: 400,
    resizeOption: 'FitToWidth',
    verticalAlign: 'Center',
    horizontalAlign: undefined,
  },
};

export function getImageConfigsProfileType(profileType: ProfileType): ThemeParamsCollection {
  return isIndividual(profileType) ? AGENT_IMAGE_CONFIGS : AGENCY_IMAGE_CONFIGS;
}

export function getImageConfigByImageType(imageType: ProfileThemeImageType, profileType: ProfileType): ThemeParams {
  const profileImageConfigs = getImageConfigsProfileType(profileType);
  return profileImageConfigs[imageType];
}
